// extracted by mini-css-extract-plugin
export var closeButton = "_p3-2";
export var closeButtonIcon = "_p3-3";
export var lightboxContent = "_p3-1";
export var lightboxOverlay = "_p3-0";